import React, { useEffect } from 'react';

// import { DashboardOutlined } from '@ant-design/Icons';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';

// ==============================|| MENU ITEMS ||============================== //

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const iconSize = 20;
  const selectedModule = useSelector((state) => state.moduleView);
  const { t } = useTranslation();

  const module = selectedModule === 'prod' ? 'MBMR' : 'MBPR';
  //selectedModule === "prod" ? navigate() : navigate();
  useEffect(() => {
    if (location.pathname === '/recipe-view' || location.pathname === '/pack-mbpr') {
      selectedModule === 'prod' ? navigate('/recipe-view') : navigate('/pack-mbpr');
    }
  }, [selectedModule, location.pathname, navigate]);

  const moduleKey = module; // "MBMR" or "MBPR"
  const moduleLabel = t(moduleKey); // localized label, if provided
  const recordKey = moduleKey === 'MBMR' ? 'BMR' : 'BPR';

  return [
    {
      id: 'group-dashboard',
      // title: "Menu",
      type: 'group',
      children: [
        // {
        //   id: "DashBoard",
        //   title: "DashBoard",
        //   type: "item",
        //   icon: () => <Icons.LayoutDashboard size={iconSize} />,
        //   // url: "https://89.116.20.149:3000/d/de6ed3t3mek8wf/batch-processing-3?from=now-2y&to=now&timezone=Asia%2FKolkata&var-Recipe=PL-3&var-Parameter=IP%20Rating&var-yield_percentage=%5B0%20-%20100%5D&var-Batch_Number=$__all&var-Quality=GOOD&var-Batch_Size=1&kiosk=&var-Product=Internal%20Demo&editIndex=6",
        //   target: "_blank", // Open in a new tab
        //   url: "/dash",
        //   breadcrumbs: true,
        //   showMenu: accessControlUtils("Dashboard")?.read_access,
        // },
        {
          id: 'DashBoard',
          title: t('DashBoard'),
          type: 'item',
          icon: () => <Icons.LayoutDashboard size={iconSize} />,
          url: '/mbmr-dash',
          // target: "_blank", // Open in a new tab
          // url: "/dash",
          breadcrumbs: true,
          showMenu: accessControlUtils('Dashboard')?.read_access,
        },
        {
          id: 'ticket',
          title: 'PR',
          type: 'item',
          url: '/ticket',
          icon: () => <Icons.Ticket size={iconSize} />,
          breadcrumbs: true,
          showMenu: accessControlUtils('PR')?.read_access,
        },
        {
          id: 'Recipe',
          title: moduleLabel,
          type: 'collapse',
          icon: () => <Icons.Package size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils(moduleKey)?.read_access ||
            accessControlUtils(`View ${moduleKey}`)?.read_access ||
            accessControlUtils(`${moduleKey} Approval`)?.read_access ||
            accessControlUtils('Process Approval')?.read_access ||
            accessControlUtils(`Prod ${moduleKey} Approval`)?.read_access,

          children: [
            {
              id: 'view_recipe',
              title: t(`View ${moduleKey}`),
              type: 'item',
              icon: () => <Icons.LayoutGrid size={iconSize} />,
              url: selectedModule === 'prod' ? '/recipe-view' : '/pack-mbpr',
              //  url: "/viewRecipe",
              breadcrumbs: true,
              showMenu: accessControlUtils(`View ${moduleKey}`)?.read_access,
            },
            {
              id: 'recipe-approval',
              title: t(`${moduleKey} Approval`),
              type: 'item',
              icon: () => <Icons.CheckCircle size={iconSize} />,
              url: '/recipe-approval',
              breadcrumbs: true,
              showMenu: accessControlUtils(`${moduleKey} Approval`)?.read_access,
            },

            {
              id: 'archive_recipe',
              title: t(`Archive ${moduleKey}`),
              type: 'item',
              icon: () => <Icons.Archive size={iconSize} />,
              url: '/archive-recipe',
              breadcrumbs: true,
              showMenu: accessControlUtils(`Archive ${moduleKey}`)?.read_access,
            },
            {
              id: 'process_approval',
              title: t('Process Approval'),
              type: 'item',
              icon: () => <Icons.Repeat size={iconSize} />,
              url: '/processApproval',
              breadcrumbs: true,
              showMenu: accessControlUtils('Process Approval')?.read_access,
            },
            {
              id: 'prod_recipe_approval',
              title: t(`${moduleKey} Rollout`),
              type: 'item',
              icon: () => <Icons.Rocket size={iconSize} />,
              url: '/prod-recipe-approval',
              breadcrumbs: true,
              showMenu: accessControlUtils(`Prod ${moduleKey} Approval`)?.read_access,
            },
          ],
        },
        {
          id: 'Batches',
          title: t('Execution Manager'),
          type: 'collapse',
          icon: () => <Icons.PlaySquare size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('Execution Manager')?.read_access ||
            accessControlUtils(`${recordKey} Details`)?.read_access ||
            accessControlUtils(`${recordKey} Tracking`)?.read_access ||
            accessControlUtils('Sample Testing')?.read_access ||
            accessControlUtils(`${recordKey} Approval`)?.read_access,
          children: [
            {
              id: 'batch_details',
              title: t(`${recordKey} Details`),
              type: 'item',
              icon: () => <Icons.ClipboardList size={iconSize} />,
              url: '/batches',
              breadcrumbs: true,
              showMenu: accessControlUtils(`${recordKey} Details`)?.read_access,
            },
            {
              id: 'bmr_tracking',
              title: t(`${recordKey} Tracking`),
              type: 'item',
              icon: () => <Icons.Activity size={iconSize} />,
              url: '/bmr-tracking',
              breadcrumbs: true,
              showMenu:
                accessControlUtils(`${recordKey} Tracking`)?.read_access ||
                accessControlUtils(`${recordKey} Details`)?.read_access,
            },
            {
              id: 'batch_traceability',
              title: t('Batch Traceability'),
              type: 'item',
              icon: () => <Icons.LayoutDashboard size={iconSize} />,
              url: '/batch-traceability',
              breadcrumbs: true,
              showMenu:
                accessControlUtils('Batch Traceability')?.read_access ||
                accessControlUtils(`${recordKey} Details`)?.read_access,
            },
            {
              id: 'sample_testing',
              title: t('Sample Testing'),
              type: 'item',
              icon: () => <Icons.FlaskConical size={iconSize} />,
              url: '/sample-testing',
              breadcrumbs: true,
              showMenu: accessControlUtils('Sample Testing')?.read_access,
            },
            {
              id: 'batch-approval',
              title: t(`${recordKey} Approval`),
              type: 'item',
              icon: () => <Icons.CheckCircle size={iconSize} />,
              url: '/batch-approval',
              breadcrumbs: true,
              showMenu: accessControlUtils(`${recordKey} Approval`)?.read_access,
            },
          ],
        },

        {
          id: 'logs',
          title: t('Logs'),
          type: 'collapse',
          icon: () => <Icons.ScrollText size={iconSize} />,
          breadcrumbs: true,
          showMenu: accessControlUtils('Logs')?.read_access,
          children: [
            {
              id: 'batch_logbook',
              title: t('Batch LogBook'),
              type: 'item',
              icon: () => <Icons.BookOpen size={iconSize} />,
              url: '/batch-logbook',
              breadcrumbs: true,
              showMenu: accessControlUtils('Batch LogBook')?.read_access,
            },
            {
              id: 'cleaning_logs',
              title: t('Cleaning Logs'),
              type: 'item',
              icon: () => <Icons.Sparkles size={iconSize} />,
              url: '/cleaning-logs',
              breadcrumbs: true,
              showMenu: accessControlUtils('Cleaning Logs')?.read_access,
            },
            {
              id: 'equipment_logs',
              title: t('Equipment Logs'),
              type: 'item',
              icon: () => <Icons.Activity size={iconSize} />,
              url: '/equipment-logs',
              breadcrumbs: true,
              showMenu: accessControlUtils('Equipment Logs')?.read_access,
            },
            {
              id: 'audit-logs',
              title: t('Audit Logs'),
              type: 'item',
              icon: () => <Icons.Shield size={iconSize} />,
              url: '/audit-logs',
              breadcrumbs: true,
              showMenu: accessControlUtils('Audit Report')?.read_access,
            },
            {
              id: 'event_logs',
              title: t('Event Logs'),
              type: 'item',
              icon: () => <Icons.Workflow size={iconSize} />,
              url: '/event-logs',
              breadcrumbs: true,
              showMenu: accessControlUtils('Event Logs')?.read_access || true,
            },
          ],
        },

        {
          id: 'report',
          title: t('Reports'),
          type: 'collapse',
          icon: () => <Icons.FileText size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('Report')?.read_access ||
            accessControlUtils('Report Details')?.read_access ||
            accessControlUtils('Audit Report')?.read_access,
          children: [
            {
              id: 'change-history-audit',
              title: t('Change History Audit'),
              type: 'item',
              icon: () => <Icons.ClipboardList size={iconSize} />,
              url: '/change-history-audit',
              breadcrumbs: true,
              showMenu: accessControlUtils('Audit Report')?.read_access,
            },
            {
              id: 'report-template-config',
              title: t('Report Template Config'),
              type: 'item',
              icon: () => <Icons.Settings size={iconSize} />,
              url: '/report-template-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Report')?.read_access,
            },
            {
              id: 'report-details',
              title: t('Report Details'),
              type: 'item',
              icon: () => <Icons.File size={iconSize} />,
              url: '/result',
              breadcrumbs: true,
              showMenu: accessControlUtils('Report Details')?.read_access,
            },
          ],
        },
        {
          id: 'administartion',
          title: t('Administration'),
          type: 'collapse',
          icon: () => <Icons.ShieldCheck size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('User Management')?.read_access ||
            accessControlUtils('Shift Details')?.read_access ||
            accessControlUtils('Application Setting')?.read_access ||
            accessControlUtils('Access Control')?.read_access,
          children: [
            {
              id: 'user-management',
              title: t('User Management'),
              type: 'item',
              icon: () => <Icons.Users size={iconSize} />,
              url: '/user-management',
              breadcrumbs: true,
              showMenu: accessControlUtils('User Management')?.read_access,
            },
            {
              id: 'training-configuration',
              title: t('Training Configuration'),
              type: 'item',
              icon: () => <Icons.ClipboardCheck size={iconSize} />,
              url: '/training-configuration',
              breadcrumbs: true,
              showMenu: accessControlUtils('Training Configuration')?.read_access,
            },
            {
              id: 'company-settings',
              title: t('Company Settings'),
              type: 'item',
              icon: () => <Icons.Settings size={iconSize} />,
              url: '/company-settings',
              breadcrumbs: true,
              showMenu: accessControlUtils('Company Settings')?.read_access,
            },
            {
              id: 'shift-management',
              title: t('Shift Management'),
              type: 'item',
              icon: () => <Icons.Users size={iconSize} />,
              url: '/shift-management',
              breadcrumbs: true,
              showMenu: accessControlUtils('Shift Management')?.read_access,
            },
            {
              id: 'shift-details',
              title: t('Shift Details'),
              type: 'item',
              icon: () => <Icons.Clock size={iconSize} />,
              url: '/shift-details',
              breadcrumbs: true,
              showMenu: accessControlUtils('Shift Details')?.read_access,
            },
            {
              id: 'employee-availability',
              title: t('Employee Availability'),
              type: 'item',
              icon: () => <Icons.CalendarDays size={iconSize} />,
              url: '/employee-availability',
              breadcrumbs: true,
              showMenu: accessControlUtils('Employee Availability')?.read_access,
            },
            {
              id: 'employee-preferences',
              title: t('Employee Preferences'),
              type: 'item',
              icon: () => <Icons.UserCog size={iconSize} />,
              url: '/employee-preferences',
              breadcrumbs: true,
              showMenu: accessControlUtils('Employee Preferences')?.read_access,
            },
            {
              id: 'appliction_setting',
              title: t('Application Setting'),
              type: 'item',
              icon: () => <Icons.Settings size={iconSize} />,
              url: '/app-setting',
              breadcrumbs: true,
              showMenu: accessControlUtils('Application Setting')?.read_access,
            },
            {
              id: 'plant-configuration',
              title: t('Plant Configuration'),
              type: 'item',
              icon: () => <Icons.Factory size={iconSize} />,
              url: '/plant-configuration',
              breadcrumbs: true,
              showMenu: accessControlUtils('Plant Configuration')?.read_access,
            },
            // {
            //   id: 'hierarchy-definition',
            //   title: t('Locations'),
            //   type: 'item',
            //   icon: () => <Icons.MapPin size={iconSize} />,
            //   url: '/hierarchy-definition',
            //   breadcrumbs: true,
            //   showMenu: true,
            // },
            // {
            //   id: 'hierarchy-levels',
            //   title: t('Level Setup'),
            //   type: 'item',
            //   icon: () => <Icons.GitBranch size={iconSize} />,
            //   url: '/hierarchy-levels',
            //   breadcrumbs: true,
            //   showMenu: true,
            // },

            // {
            //   id: "Form Builder",
            //   title: "Form Builder",
            //   type: "item",
            //   icon: () => <Icons.PencilLine size={iconSize} />,
            //   url: "/formBuilder",
            //   breadcrumbs: true,
            //   showMenu: true,
            // },
          ],
        },
        {
          id: 'contentmanager',
          title: t('Content & Templates'),
          type: 'collapse',
          icon: () => <Icons.FolderCog size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('Content Manager')?.read_access ||
            accessControlUtils('Standard Block')?.read_access ||
            accessControlUtils('Checklist')?.read_access ||
            accessControlUtils('Operation Type Config')?.read_access,
          children: [
            {
              id: 'operationtype',
              title: t('Custom Operation'),
              type: 'item',
              icon: () => <Icons.ClipboardList size={iconSize} />,
              url: '/operation-type',
              breadcrumbs: true,
              showMenu: accessControlUtils('Operation Type Config')?.read_access,
            },
            {
              id: 'standardBlock',
              title: t('Standard Block'),
              type: 'item',
              icon: () => <Icons.Puzzle size={iconSize} />,
              url: '/standard-block',
              breadcrumbs: true,
              showMenu: accessControlUtils('Standard Block')?.read_access,
            },
            {
              id: 'form',
              title: t('Forms'),
              type: 'item',
              icon: () => <Icons.ListChecks size={iconSize} />,
              url: '/form',
              breadcrumbs: true,
              showMenu: accessControlUtils('Forms')?.read_access,
            },
          ],
        },
        {
          id: 'qualitymanager',
          title: t('Quality & Compliance'),
          type: 'collapse',
          icon: () => <Icons.CheckCheck size={iconSize} />,
          breadcrumbs: true,
          showMenu: false, // Hidden per user request
          children: [
            {
              id: 'workflow',
              title: t('Workflow Management'),
              type: 'item',
              icon: () => <Icons.Workflow size={iconSize} />,
              breadcrumbs: true,
              url: '/work-flow',
              showMenu: accessControlUtils('Quality Manager')?.read_access,
            },
          ],
        },
        {
          id: 'masterdata',
          title: t('Master Data'),
          type: 'collapse',
          icon: () => <Icons.Database size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('Product Master')?.read_access ||
            accessControlUtils('Material')?.read_access ||
            accessControlUtils('Equipment Master')?.read_access ||
            accessControlUtils('Machine')?.read_access ||
            accessControlUtils('Machine Type Config')?.read_access,
          children: [
            {
              id: 'product',
              title: t('Product Master'),
              type: 'item',
              icon: () => <Icons.Layers size={iconSize} />,
              url: '/prod-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Product Master')?.read_access,
            },
            {
              id: 'material',
              title: t('Material'),
              type: 'item',
              icon: () => <Icons.FlaskConical size={iconSize} />,
              url: '/material-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Material')?.read_access,
            },
            {
              id: 'equipment',
              title: t('Equipment Master'),
              type: 'item',
              icon: () => <Icons.Factory size={iconSize} />,
              url: '/equipment-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Equipment Master')?.read_access,
            },
            {
              id: 'machine',
              title: t('Machine'),
              type: 'item',
              icon: () => <Icons.Cog size={iconSize} />,
              url: '/machine-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Machine')?.read_access,
            },
          ],
        },
        {
          id: 'configuration',
          title: t('Configuration'),
          type: 'collapse',
          icon: () => <Icons.Settings size={iconSize} />,
          breadcrumbs: true,
          showMenu:
            accessControlUtils('Configuration')?.read_access ||
            accessControlUtils('Room Config')?.read_access ||
            accessControlUtils('Parameter')?.read_access ||
            accessControlUtils('Area Config')?.read_access ||
            accessControlUtils('Sensor')?.read_access ||
            accessControlUtils('Quality Control')?.read_access,
          children: [
            {
              id: 'room_config',
              title: t('Room'),
              type: 'item',
              icon: () => <Icons.FlaskConical size={iconSize} />,
              url: '/roomConfig',
              breadcrumbs: true,
              showMenu: accessControlUtils('Room Config')?.read_access,
            },
            {
              id: 'parameter',
              title: t('Parameter'),
              type: 'item',
              icon: () => <Icons.SlidersHorizontal size={iconSize} />,
              url: '/param-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Parameter')?.read_access,
            },
            {
              id: 'transfer_path_config',
              title: t('Transfer Path'),
              type: 'item',
              icon: () => <Icons.GitFork size={iconSize} />,
              url: '/transfer-path-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Parameter')?.read_access,
            },
            // {
            //   id: 'process_control_config',
            //   title: t('Process Control'),
            //   type: 'item',
            //   icon: () => <Icons.Activity size={iconSize} />,
            //   url: '/process-control-config',
            //   breadcrumbs: true,
            //   showMenu: accessControlUtils('Parameter')?.read_access,
            // },
            {
              id: 'control_category_config',
              title: t('Control Category'),
              type: 'item',
              icon: () => <Icons.Cog size={iconSize} />,
              url: '/control-category-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Parameter')?.read_access,
            },
            {
              id: 'process_control_parameter_config',
              title: t('Process Control Name'),
              type: 'item',
              icon: () => <Icons.SlidersHorizontal size={iconSize} />,
              url: '/process-control-parameter-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Parameter')?.read_access,
            },
            {
              id: 'areaConfig',
              title: t('Area'),
              type: 'item',
              icon: () => <Icons.Layers size={iconSize} />,
              url: '/areaConfig',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'sensor',
              title: t('Sensor'),
              type: 'item',
              icon: () => <Icons.Radar size={iconSize} />,
              url: '/sensor',
              breadcrumbs: true,
              showMenu: accessControlUtils('Sensor')?.read_access,
            },
            {
              id: 'cleaning',
              title: t('Cleaning Type'),
              type: 'item',
              icon: () => <Icons.Sparkles size={iconSize} />,
              url: '/cleaningTypes',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'actionlist-fields',
              title: t('ActionList Fields'),
              type: 'item',
              icon: () => <Icons.ListChecks size={iconSize} />,
              url: '/actionListFields',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'test_type',
              title: t('Sample Test Type'),
              type: 'item',
              icon: () => <Icons.FlaskConical size={iconSize} />,
              url: '/test-type',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'apicalc_type',
              title: t('Api Calc Type'),
              type: 'item',
              icon: () => <Icons.Calculator size={iconSize} />,
              url: '/apicalc-field',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'clearance_type',
              title: t('Clearance Type'),
              type: 'item',
              icon: () => <Icons.Sparkles size={iconSize} />,
              url: '/clearance-type',
              breadcrumbs: true,
              showMenu: accessControlUtils('Area Config')?.read_access,
            },
            {
              id: 'machine_type_config',
              title: t('Machine Type'),
              type: 'item',
              icon: () => <Icons.Cpu size={iconSize} />,
              url: '/machine-type-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Machine')?.read_access,
            },
            {
              id: 'qualitycontrol',
              title: t('Quality Control'),
              type: 'item',
              icon: () => <Icons.ShieldCheck size={iconSize} />,
              url: '/sample-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Quality Control')?.read_access,
            },
            {
              id: 'system_integration',
              title: t('System Integration'),
              type: 'item',
              icon: () => <Icons.Settings size={iconSize} />,
              url: '/system-integration',
              breadcrumbs: true,
              showMenu: true || accessControlUtils('Configuration')?.read_access,
            },
            // {
            //   id: "dashboardUrl",
            //   title: t("URL Config"),
            //   type: "item",
            //   icon: () => <Icons.Globe size={iconSize} />,
            //   url: "/url-config",
            //   breadcrumbs: true,
            //   showMenu: accessControlUtils("URL Config")?.read_access,
            // },
            {
              id: 'licence-config',
              title: t('Licence'),
              type: 'item',
              icon: () => <Icons.Shield size={iconSize} />,
              url: '/licence-config',
              breadcrumbs: true,
              showMenu: accessControlUtils('Licence')?.read_access,
            },
            {
              id: 'master-config',
              title: t('General Config'),
              type: 'item',
              icon: () => <Icons.Database size={iconSize} />,
              url: '/master-config',
              breadcrumbs: true,
              showMenu: true,
            },
          ],
        },
        // {
        //   id: "plantselect",
        //   title: "Plant Select",
        //   type: "item",
        //   icon: () => <Icons.Lock size={iconSize} />,
        //   url: "/plant-select",
        //   breadcrumbs: true,
        //   showMenu: true,
        //   // selectedModule === "prod",
        // },
        {
          id: 'quality-management',
          title: t('Quality Management'),
          type: 'collapse',
          icon: () => <Icons.Shield size={iconSize} />,
          breadcrumbs: true,
          showMenu: accessControlUtils('Quality Management')?.read_access,
          children: [
            {
              id: 'batch-genealogy-full',
              title: t('Batch Genealogy'),
              type: 'item',
              icon: () => <Icons.GitBranch size={iconSize} />,
              url: '/batch-genealogy-full',
              breadcrumbs: true,
              showMenu: accessControlUtils('Batch Genealogy')?.read_access,
            },
          ],
        },
        // {
        //   id: 'change-control',
        //   title: t('Change Control'),
        //   type: 'collapse',
        //   icon: () => <Icons.GitBranch size={iconSize} />,
        //   breadcrumbs: true,
        //   showMenu: accessControlUtils('Change Control')?.read_access,
        //   children: [
        //     {
        //       id: 'change-control-overview',
        //       title: t('Change Control Overview'),
        //       type: 'item',
        //       icon: () => <Icons.Archive size={iconSize} />,
        //       url: '/change-control',
        //       breadcrumbs: true,
        //       showMenu: accessControlUtils('Change Control Overview')?.read_access,
        //     },
        //     {
        //       id: 'recipe-versioning',
        //       title: t('Recipe Versioning'),
        //       type: 'item',
        //       icon: () => <Icons.Package size={iconSize} />,
        //       url: '/recipe-versioning',
        //       breadcrumbs: true,
        //       showMenu: accessControlUtils('Recipe Versioning')?.read_access,
        //     },
        //     {
        //       id: 'standard-block-versioning',
        //       title: t('Standard Block Versioning'),
        //       type: 'item',
        //       icon: () => <Icons.Blocks size={iconSize} />,
        //       url: '/standard-block-versioning',
        //       breadcrumbs: true,
        //       showMenu: accessControlUtils('Standard Block Versioning')?.read_access,
        //     },
        //   ],
        // },
        // {
        //   id: 'workflow',
        //   title: t('Workflow Management'),
        //   type: 'collapse',
        //   icon: () => <Icons.Settings size={iconSize} />,
        //   breadcrumbs: true,
        //   showMenu: accessControlUtils('Workflow Management')?.read_access,
        //   children: [
        //     {
        //       id: 'workflow-automation',
        //       title: t('Workflow Automation'),
        //       type: 'item',
        //       icon: () => <Icons.Rocket size={iconSize} />,
        //       url: '/workflow-automation',
        //       breadcrumbs: true,
        //       showMenu: accessControlUtils('Workflow Automation')?.read_access,
        //     },
        //   ],
        // },
        {
          id: 'Support',
          title: t('Support'),
          type: 'item',
          icon: () => <Icons.HelpCircle size={iconSize} />,
          url: 'https://nexgensis-1.gitbook.io/pidilite-batch-processing-web-application/',
          external: true,
          target: true,
          showMenu: accessControlUtils('Support')?.read_access,
          breadcrumbs: true,
          iconCollapsed: Icons.HelpCircle,
        },
      ].filter(Boolean),
    },
  ];
}

export default Dashboard;
